import api from './index';

const authAPI = {
  localAuth: () => {
    return api.post('/local_auth');
  },

  // Register a new user
  register: (userData) => {
    return api.post('/register_plain', userData);
  },
  
  // Login with email and password
  login: (credentials) => {
    return api.post('/login_plain', credentials);
  },
  
  // Request WhatsApp verification code
  requestWhatsAppCode: (identifier = null) => {
    const data = {};
    if (identifier) {
      const trimmedIdentifier = identifier.trim();
      if (trimmedIdentifier.includes('@')) {
        data.email = trimmedIdentifier;
      } else {
        data.phone_number = trimmedIdentifier;
      }
    }
    return api.post('/request_whatsapp_code', data);
  },
  
  // Verify WhatsApp code
  verifyWhatsAppCode: (code, identifier = null) => {
    const data = {
      verification_code: code
    };
    
    if (identifier) {
      const trimmedIdentifier = identifier.trim();
      if (trimmedIdentifier.includes('@')) {
        data.email = trimmedIdentifier;
      } else {
        data.phone_number = trimmedIdentifier;
      }
    }
    
    return api.post('/verify_whatsapp_code', data);
  },

  // Current applicant user data for local development auth bypass.
  getCurrentApplicantUser: () => {
    return api.get('/applicants/user');
  },
  
  // Request password reset
  requestPasswordReset: (email) => {
    return api.post('/request_reset_password', { email });
  },
  
  // Verify password reset code
  verifyPasswordResetCode: (email, code) => {
    return api.post('/verify_reset_password_code', {
      email,
      verification_code: code
    });
  },
  
  // Reset password
  resetPassword: (newPassword, token) => {
    return api.post('/reset_password', 
      { new_password: newPassword },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
  }
};

export default authAPI;
